import { supabase } from "@/integrations/supabase/client";

/**
 * Submit URLs to IndexNow for instant indexing by search engines
 */
export const submitToIndexNow = async (urls: string | string[]) => {
  try {
    const urlArray = Array.isArray(urls) ? urls : [urls];
    
    // Make URLs absolute if they're relative
    const absoluteUrls = urlArray.map(url => {
      if (url.startsWith('http')) return url;
      return `https://ekselencia.com${url.startsWith('/') ? '' : '/'}${url}`;
    });

    console.log('[IndexNow] Submitting URLs:', absoluteUrls);

    const { data, error } = await supabase.functions.invoke("indexnow-submit", {
      body: { urls: absoluteUrls }
    });

    if (error) {
      console.error('[IndexNow] Error:', error);
      return false;
    }

    console.log('[IndexNow] Success:', data);
    return true;
  } catch (error) {
    console.error('[IndexNow] Exception:', error);
    return false;
  }
};

/**
 * Helper to submit listing URL to IndexNow
 */
export const submitListingToIndexNow = async (slug: string, isPremium: boolean) => {
  const path = isPremium ? `/premium/${slug}` : `/listing/${slug}`;
  await submitToIndexNow(path);
};

/**
 * Helper to submit article URL to IndexNow
 */
export const submitArticleToIndexNow = async (slug: string) => {
  await submitToIndexNow(`/article/${slug}`);
};

/**
 * Helper to submit video URL to IndexNow
 */
export const submitVideoToIndexNow = async (slug: string) => {
  await submitToIndexNow(`/video/${slug}`);
};

/**
 * Helper to submit event URL to IndexNow
 */
export const submitEventToIndexNow = async (slug: string) => {
  await submitToIndexNow(`/event/${slug}`);
};

/**
 * Helper to submit trainer URL to IndexNow
 */
export const submitTrainerToIndexNow = async (slug: string) => {
  await submitToIndexNow(`/trainer/${slug}`);
};
